// Process is provided by webpack DefinePlugin at build time
declare const process: {
	env: {
		REACT_APP_AI_GATEWAY_URL?: string;
	};
};

/**
 * Base URL of the AI agents gateway. Every browser call to the gateway builds on this one
 * value so the chat and the credit usage read can never point at different hosts.
 */
export const AI_GATEWAY_URL: string = process.env.REACT_APP_AI_GATEWAY_URL || 'http://localhost:7861';
